<script lang="ts">
  import { enhance } from '$app/forms';

  let status: 'idle' | 'submitting' | 'success' | 'error' = $state('idle');
  let email = $state('');

  async function handleSubmit(event: SubmitEvent) {
    event.preventDefault();
    status = 'submitting';

    const form = event.target as HTMLFormElement;
    const formData = new FormData(form);

    try {
      // 1. Submit to Netlify (Root) - Ensures it appears in Dashboard
      await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as any).toString()
      });

      // 2. Submit to our API - Triggers the Resend Email
      const response = await fetch('/api/blueprint', {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        status = 'success';
        email = '';
      } else {
        throw new Error('Email API failed');
      }
    } catch (error) {
      console.error('Submission error:', error);
      status = 'error';
      alert('Something went wrong. Please try again.');
    }
  }
</script>

<div class="relative overflow-hidden rounded-3xl border border-[#C9A87C]/30 bg-card p-8 sm:p-12 shadow-2xl">
  <!-- Ambient background glow -->
  <div aria-hidden="true" class="absolute inset-0 pointer-events-none">
    <div class="absolute -top-24 -right-24 w-64 h-64 bg-[#C9A87C]/10 rounded-full blur-[80px]"></div>
    <div class="absolute -bottom-24 -left-24 w-64 h-64 bg-[#8E9BAF]/10 rounded-full blur-[80px]"></div>
  </div>

  <div class="relative z-10 max-w-2xl mx-auto text-center">
    <div class="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#C9A87C]/20 bg-[#C9A87C]/5 text-[#C9A87C] text-[10px] font-bold uppercase tracking-widest mb-6">
      Lead Magnet
    </div>
    
    <h2 class="font-display font-bold text-3xl sm:text-4xl mb-4 text-content">
      The "Invisible Workforce" Blueprint.
    </h2>
    <h3 class="sr-only">Get Our 7-Day Automation Audit Template</h3>
    <p class="text-dim-50 text-lg mb-10 leading-relaxed">
      Get our 7-day automation audit template and weekly insights on how to scale your output without bloating your headcount.
    </p>

    {#if status === 'success'}
      <div class="p-6 rounded-2xl bg-[#7A9E90]/10 border border-[#7A9E90]/20 text-[#7A9E90] animate-fade-up">
        <p class="font-bold mb-1">Check your inbox!</p>
        <p class="text-sm">The blueprint is on its way. Ready to build the future of your operations.</p>
      </div>
    {:else}
      <form 
        name="newsletter-blueprint"
        method="POST"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        onsubmit={handleSubmit}
        class="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
      >
        <!-- Netlify Hidden Fields -->
        <input type="hidden" name="form-name" value="newsletter-blueprint" />
        <p class="hidden">
          <label>Don’t fill this out if you’re human: <input name="bot-field" /></label>
        </p>

        <input 
          type="email" 
          name="email"
          bind:value={email}
          placeholder="work@company.com" 
          required
          class="flex-1 px-5 py-4 rounded-2xl bg-void border border-dim-10 text-content placeholder:text-dim-30 focus:outline-none focus:ring-2 focus:ring-[#C9A87C]/50 transition-all text-sm"
        />
        <button 
          type="submit"
          disabled={status === 'submitting'}
          class="px-8 py-4 rounded-2xl bg-[#C9A87C] text-[#08080E] font-bold text-sm hover:bg-[#D4B896] transition-all disabled:opacity-50 shadow-lg shadow-[#C9A87C]/20"
        >
          {status === 'submitting' ? 'Sending...' : 'Get Blueprint →'}
        </button>
      </form>
      <p class="mt-4 text-[10px] text-dim-30">
        No spam. Just high-velocity operational insights. Unsubscribe anytime.
      </p>
    {/if}
  </div>
</div>
